
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069.376-1773.57a.5.5 0 01.753 0l5.9 6.741a.5.5 0 01-.377.829h-11.8a.5.5 0 01-.376-.829z"}})])])
          )
        }
      }
    